import { combineReducers } from 'redux';

import authenticateForm from './authenticate-form';
import userCreateForm from './user-create-form';
import projectCreateForm from './project-create-form';
import cardRelationCreateForm from './card-relation-create-form';

export default combineReducers({
  authenticateForm,
  userCreateForm,
  projectCreateForm,
  cardRelationCreateForm,
});
